import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { DateRange } from 'owa-datetime-utils';
import {
    getLockedCalendarEventsReader,
    getLockedCalendarEventsStore,
    EventsCacheLockId,
} from 'owa-calendar-events-store';

// Dont export the fetch functions for full item here as this locked store
// should only be used for fetching calendar events for date range
export function fetchCalendarEventsForDateRange(
    lockId: EventsCacheLockId,
    folderId: string,
    dateRange: DateRange
): Promise<CalendarEvent[]> {
    const lockedStore = getLockedCalendarEventsStore(lockId);
    return lockedStore.fetchCalendarEventsForDateRange(folderId, dateRange).fetchPromise;
}

export function getCalendarEventsForDateRange(
    lockId: EventsCacheLockId,
    folderId: string,
    dateRange: DateRange
): CalendarEvent[] {
    const lockedStoreReader = getLockedCalendarEventsReader(lockId);
    return lockedStoreReader.getCalendarEventsForDateRange(folderId, dateRange);
}
